import { HTTPINPUTTYPE } from '../../../../../../../enums/HTTPINPUTTYPE.js';
import INPUT from '../../../../../../DOM/form/fieldset/field/input/INPUT.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
// Model Structure
export const inputTimeAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['value'],
    ['type', HTTPINPUTTYPE.TIME]
]);
export const inputTimeData = makeDataStruct([]);
export const inputTimeModel = makeStruct([
    ['attributes', inputTimeAttr],
    ['data', inputTimeData]
]);
// Simplified Model
export function inputTime(name, className, value) {
    return inputTimeModel(inputTimeAttr(name, className, value), inputTimeData());
}
// Class
export default class INPUTTIME extends INPUT {
    constructor(node, model) {
        super(node, model);
    }
}
